import { render, staticRenderFns } from "./ConfigHorariosCarga.vue?vue&type=template&id=767e2b03&"
import script from "./ConfigHorariosCarga.vue?vue&type=script&lang=js&"
export * from "./ConfigHorariosCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports